import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import axios from 'axios';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { CsrfProvider } from './contexts/CsrfContext';
import CsrfSync from './components/common/CsrfSync';
import { API_BASE_URL } from './config/api';
import './index.css';

// Configure axios defaults
axios.defaults.baseURL = API_BASE_URL;

// Prevent mouse wheel scrolling on number inputs globally
document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('wheel', (e) => {
    const target = e.target;
    if (target.type === 'number' && target === document.activeElement) {
      e.preventDefault();
    }
  }, { passive: false });
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <CsrfProvider>
        <AuthProvider>
          <CsrfSync />
          <App />
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: '#363636',
                color: '#fff',
              },
            }}
          />
        </AuthProvider>
      </CsrfProvider>
    </BrowserRouter>
  </React.StrictMode>
);